import styled from "@emotion/styled/macro";
import { colors } from "../../../../common/styles/theme.styles";

export const EntitiesPanelDrawerWrapper = styled.div`
    display: flex;
    flex-direction: column;
    max-height: 100%;
    height: 100%;
    overflow: hidden;
    flex: 1;
`;

export const EntityPanelWrapper = styled.div`
  grid-area: panel;
  width: 400px;
  height: 100%;
  background: #ffffff;
  border: 1px solid ${colors.gray3};
  border-radius: 12px;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  z-index: 10;
  position: relative;
`;

export const AnimatedPanelContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transform: translateX(${props => props.isVisible ? '0' : '100%'});
  transition: transform 0.2s ease-out;
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  z-index: ${props => props.isVisible ? '2' : '1'};
`;
